'use client';

import { useEffect } from 'react';
import type { UserProfile } from '@/entities/user-profile';
import { useNotificationsStore } from '@/shared/lib/notifications/store';


type ServerNotificationsSyncProps = {
    profile: UserProfile;
};


/** Кладёт уведомления из профиля в клиентский стор колокольчика. */
export function ServerNotificationsSync ({ profile }: ServerNotificationsSyncProps) {
    const hydrate = useNotificationsStore((s) => s.hydrate);

    useEffect(() => {
        if (profile.notifications) hydrate(profile.notifications);
    }, [ profile.notifications, hydrate ]);

    return null;
}
